import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { ShareIcon } from '../icons';
import ShareButton from '../share-button';
import ShareLink from '../share-link';
import share from '../../services/share';
import getOuterUrl from '../../services/get-outer-url';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './share-form.scss';

export class ShareForm extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    titleFontClassName: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    isLinkShareFormVisible: false,
  };

  handleLinkButtonClick = () => {
    this.setState({
      isLinkShareFormVisible: true,
    });
  };

  handleShare = socialNetwork => {
    share(socialNetwork, getOuterUrl(this.props.path));
  };

  handleCancel = () => {
    this.setState({
      isLinkShareFormVisible: false,
    });
  };

  renderShareButtons() {
    const { t } = this.props;

    return (
      <div className={styles.content}>
        <span className={styles.button}>
          <ShareButton type="facebook" title={t('share-button.via-facebook')} onClick={this.handleShare}/>
        </span>
        <span className={styles.button}>
          <ShareButton type="twitter" title={t('share-button.via-twitter')} onClick={this.handleShare}/>
        </span>
        <span className={styles.button}>
          <ShareButton type="gPlus" title={t('share-button.via-google-plus')} onClick={this.handleShare}/>
        </span>
        <span className={styles.button}>
          <ShareButton type="link" title={t('share-button.via-link')} onClick={this.handleLinkButtonClick}/>
        </span>
      </div>
    );
  }

  renderLinkShareForm() {
    const { isLinkShareFormVisible } = this.state;
    if (!isLinkShareFormVisible) {
      return null;
    }

    const { path } = this.props;
    return (
      <div className={styles.content}>
        <ShareLink url={getOuterUrl(path)} onCancel={this.handleCancel}/>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { isLinkShareFormVisible } = this.state;
    const title = isLinkShareFormVisible ? t('share-form.share-link') : this.props.title;

    return (
      <div className={classNames(styles.container, 'forum-text-color', this.props.titleFontClassName)}>
        <div className={styles.message}>
          <ShareIcon className="forum-icon-fill"/>
          <span className={styles.title}>
            {title}
          </span>
        </div>

        {isLinkShareFormVisible ? this.renderLinkShareForm() : this.renderShareButtons()}
      </div>
    );
  }
}

export default withFontClassName(withTranslate(ShareForm));



// WEBPACK FOOTER //
// ./app/components/share-form/share-form.js